import * as React from 'react'

function SvgPaper(props, svgRef) {
  return (
    <svg viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        d="M7.333 0v3.75H11L7.333 0zm-.916 3.75V0H1.375C.615 0 0 .63 0 1.406v12.188C0 14.37.616 15 1.375 15h8.25c.76 0 1.375-.63 1.375-1.406V4.688H7.36a.932.932 0 01-.943-.938zm1.375 8.438H3.208a.465.465 0 01-.458-.47c0-.257.206-.468.458-.468h4.584c.253 0 .458.21.458.469a.465.465 0 01-.458.469zm0-1.876H3.208a.465.465 0 01-.458-.468c0-.258.206-.469.458-.469h4.584c.253 0 .458.21.458.469a.465.465 0 01-.458.469zM8.25 7.97a.465.465 0 01-.458.468H3.208a.465.465 0 01-.458-.468c0-.258.206-.469.458-.469h4.584c.252 0 .458.21.458.469z"
        fill="#204667"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgPaper)
export default ForwardRef
